import { AuthShell, buttonVariants, cn } from "@nexys/user-management-web";
import { AlertCircle, MailCheck } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";

/** Server redirect target after a successful email verification. */
export const AuthVerifiedPage = () => (
  <AuthShell brand="UM-RS Console">
    <div className="grid w-full max-w-md gap-4 text-center">
      <MailCheck className="mx-auto size-10 text-green-600" />
      <h1 className="text-2xl font-semibold">Email verified</h1>
      <p className="text-sm text-muted-foreground">
        Your email address has been confirmed. You can sign in now.
      </p>
      <Link to="/sign-in" className={cn(buttonVariants(), "w-full")}>
        Go to sign in
      </Link>
    </div>
  </AuthShell>
);

/**
 * Server redirect target when an auth flow fails — expired magic
 * links, refused social sign-ins, bad verification tokens.
 */
export const AuthErrorPage = () => {
  const [params] = useSearchParams();
  const code = params.get("error");

  return (
    <AuthShell brand="UM-RS Console">
      <div className="grid w-full max-w-md gap-4 text-center">
        <AlertCircle className="mx-auto size-10 text-destructive" />
        <h1 className="text-2xl font-semibold">Sign-in problem</h1>
        <p className="text-sm text-muted-foreground">
          That link or sign-in attempt couldn't be completed — it may have
          expired, already been used, or been refused for safety.
        </p>
        {code ? (
          <code className="mx-auto rounded bg-muted px-2 py-1 font-mono text-xs">
            {code}
          </code>
        ) : null}
        <Link to="/sign-in" className={cn(buttonVariants(), "w-full")}>
          Back to sign in
        </Link>
      </div>
    </AuthShell>
  );
};
